import { Link } from "@tanstack/react-router";
import { BadgeCheckIcon, BellIcon, ChevronsUpDownIcon, LogOutIcon, ShieldCheckIcon, SparklesIcon } from "lucide-react";

import { PreviewableImage } from "@/components/media/image-preview-dialog";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useCurrentUser } from "@/lib/query/use-current-user";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { resolveMediaSrc } from "@/lib/media-src";

export function NavUser() {
  const { isMobile } = useSidebar();
  const user = useCurrentUser();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="size-8 rounded-lg">
                <AvatarImage src={resolveMediaSrc(user.avatar) ?? undefined} alt={user.name} />
                <AvatarFallback className="rounded-lg">{user.initials}</AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-start text-sm leading-tight group-data-[collapsible=icon]:hidden">
                <span className="truncate font-semibold">{user.name}</span>
                <span className="truncate text-xs text-muted-foreground">{user.email}</span>
              </div>
              <ChevronsUpDownIcon className="ms-auto size-4 group-data-[collapsible=icon]:hidden" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-64 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="font-normal">
              <div className="flex items-center gap-3 px-1 py-1">
                {user.avatar ? (
                  <PreviewableImage
                    src={user.avatar}
                    alt={user.name}
                    title={user.name}
                    className="size-9 shrink-0 rounded-lg"
                    imageClassName="rounded-lg"
                  />
                ) : (
                  <Avatar className="size-9 rounded-lg">
                    <AvatarFallback className="rounded-lg">{user.initials}</AvatarFallback>
                  </Avatar>
                )}
                <div className="grid text-start">
                  <span className="font-semibold">{user.name}</span>
                  <span className="text-xs text-muted-foreground">{user.role}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem asChild>
                <Link to="/nguoi-dung">
                  <BadgeCheckIcon className="size-4" />
                  Hồ sơ và quyền
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/he-thong/thong-bao">
                  <BellIcon className="size-4" />
                  Thông báo vận hành
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/he-thong/feature-flags">
                  <ShieldCheckIcon className="size-4" />
                  Cờ hệ thống
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/ho-tro/phat-nguyen/nhap-ho">
                  <SparklesIcon className="size-4" />
                  Nhập hộ phát nguyện
                </Link>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild className="text-destructive focus:text-destructive">
              <Link to="/auth/dang-nhap">
                <LogOutIcon className="size-4" />
                Đăng xuất
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
